import { useEffect } from "react"

const decimalCommaToDotString = (value) => {
  if (!value) return ""
  return String(value).replace(",", ".")
}

export const useEmitIdEffect = (caracteristicasState, setCaracteristicasState) => {
  useEffect(() => {
    const gerarIdEmissao = (values = {}) =>
      (
        `${values.tipoAtivo || ""}_` +
        `${values.devedor || ""}_` +
        `${values.dataEmissao || ""}_` +
        `${values.dataVencimento || ""}_` +
        `${values.indexador || ""}_` +
        `${decimalCommaToDotString(values.remuneracao) || ""}_` +
        `${values.versaoDocumento ?? ""}`
      ).toUpperCase()

    const novoId = gerarIdEmissao(caracteristicasState)

    if (caracteristicasState.emissao !== novoId) {
      setCaracteristicasState(prev => ({
        ...prev,
        emissao: novoId
      }))
    }
  }, [
    caracteristicasState.tipoAtivo,
    caracteristicasState.devedor,
    caracteristicasState.dataEmissao,
    caracteristicasState.dataVencimento,
    caracteristicasState.indexador,
    caracteristicasState.remuneracao,
    caracteristicasState.versaoDocumento,
    setCaracteristicasState
  ])
}
